import { DownloadStatusType } from "../models/download.interface";
import { IActionBase } from '../models/root.interface';
import { DOWNLOAD_STATUS } from "../actions/download.action";


const initialState: DownloadStatusType = {
    downloadStatus: true
};
function DownloadReducer(state: DownloadStatusType = initialState, action: IActionBase): DownloadStatusType {
    switch (action.type) {
        case DOWNLOAD_STATUS: {
            return { ...state, downloadStatus: action.downloadStatus };
        }
        default:
            return state;
    }
}


export default DownloadReducer;